module.exports = __webpack_public_path__ + "static/media/student-end-season-root-bg.86e72381.jpg";